/*
| software | id |
| ---------- | --- |
| Maya | 2000 |
| 3ds Max | 2001 |
| Lightwave | 2002 |
| Arnold Standalone | 2003 |
| Houdini | 2004 |
| Cinema 4D | 2005 |
| Softimage | 2006 |
| Blender | 2007 |
| VR Standalone | 2008 |
| MR Standalone | 2009 |
| SketchUp | 2010 |
| VUE | 2011 |
| KeyShot | 2012 |
| Clarisse | 2013 |
| Octane Render | 2014 |
| Nuke | 2015 |
| Katana | 2016 |
| ContextCapture | 2017 |
| Terragen | 2018 |
| UnrealEngine | 2020 |
| CustomSoftware | 2030 |
*/

export enum SoftwareID {
  /** Maya */
  Maya = 2000,
  /** Max */
  Max = 2001,
  /** Lightwave */
  Lightwave = 2002,
  /** ArnoldStandalone */
  ArnoldStandalone = 2003,
  /** Houdini */
  Houdini = 2004,
  /** Cinema4D */
  Cinema4D = 2005,
  /** Softimage */
  Softimage = 2006,
  /** Blender */
  Blender = 2007,
  /** VRStandalone */
  VRStandalone = 2008,
  /** MRStandalone */
  MRStandalone = 2009,
  /** SketchUp */
  SketchUp = 2010,
  /** VUE */
  VUE = 2011,
  /** KeyShot */
  KeyShot = 2012,
  /** Clarisse */
  Clarisse = 2013,
  /** OctaneRender */
  OctaneRender = 2014,
  /** Nuke */
  Nuke = 2015,
  /** Katana */
  Katana = 2016,
  /** ContextCapture */
  ContextCapture = 2017,
  /** Terragen */
  Terragen = 2018,
  /** Creole */
  Creole = 2019,
  /** UnrealEngine */
  UnrealEngine = 2020,
  /** Gaffer */
  Gaffer = 2021,
  /** Vred */
  Vred = 2022,
  /** CustomSoftware */
  CustomSoftware = 2030,
  /** Aftereffects */
  Aftereffects = 2023,
}

export enum Software {
  Maya = "Maya",
  Max = "3ds Max",
  Lightwave = "Lightwave",
  ArnoldStandalone = "Arnold Standalone",
  Houdini = "Houdini",
  Cinema4D = "Cinema 4D",
  Softimage = "Softimage",
  Blender = "Blender",
  VRStandalone = "V-Ray Standalone",
  MRStandalone = "MR Standalone",
  SketchUp = "SketchUp",
  VUE = "VUE",
  KeyShot = "KeyShot",
  Clarisse = "Clarisse",
  OctaneRender = "Octane Render",
  Nuke = "Nuke",
  Katana = "Katana",
  ContextCapture = "Context Capture",
  Terragen = "Terragen",
  Creole = "Creole",
  UnrealEngine = "Unreal Engine",
  CustomSoftware = "Custom software",
  VRED = "VRED",
  Gaffer = "Gaffer",
  Vred = "Vred",
  Aftereffects = "Aftereffects",
}

export function getSoftwareNameById(softwareId: SoftwareID): string {
  const softwareKeys = Object.keys(SoftwareID) as (keyof typeof SoftwareID)[];
  const softwareKey = softwareKeys.find(
    (key) => SoftwareID[key as keyof typeof SoftwareID] === softwareId
  );

  if (softwareKey) {
    return Software[softwareKey as keyof typeof Software];
  }

  return "";
}

export const SoftwareImg = new Map([
  [SoftwareID.Maya, "maya.png"],
  [SoftwareID.Max, "max.png"],
  [SoftwareID.ArnoldStandalone, "Arnold-standalone.png"],
  [SoftwareID.Houdini, "houdini.png"],
  [SoftwareID.Cinema4D, "cinema-4D.png"],
  [SoftwareID.Blender, "blender.png"],
  [SoftwareID.VRStandalone, "VR-standalone.png"],
  [SoftwareID.SketchUp, "sketchup.png"],
  [SoftwareID.VUE, "vue.png"],
  [SoftwareID.KeyShot, "keyshot.png"],
  [SoftwareID.Clarisse, "clarisse.png"],
  [SoftwareID.Nuke, "nuke.png"],
  [SoftwareID.Katana, "klatana-.png"],
  [SoftwareID.ContextCapture, "context_capture.png"],
  [SoftwareID.Terragen, "terragen.png"],
  [SoftwareID.Creole, "creole.png"],
  [SoftwareID.UnrealEngine, "unreal-engine.png"],
  [SoftwareID.Gaffer, "gaffer.png"],
  [SoftwareID.Vred, "vred.png"],
  [SoftwareID.CustomSoftware, "custom-software.png"],
  [SoftwareID.Aftereffects, "aftereffects.png"],
]);

export enum RenderSystem {
  Linux,
  Windows,
}
